import { render, staticRenderFns } from "./MariaSales.vue?vue&type=template&id=04327f5b"
import script from "./MariaSales.vue?vue&type=script&lang=js"
export * from "./MariaSales.vue?vue&type=script&lang=js"
import style0 from "./MariaSales.vue?vue&type=style&index=0&id=04327f5b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports